





























import { Getter, Action } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import html2canvas from "html2canvas";

import CONFIG from "@/common/config";
import fetch from "@/common/api/fetch";

import getUrlParam from '@/common/utils/getUrlParam';
import { replaceString } from '@/common/utils/dealWithString';
import getActivityType from '@/common/utils/getActivityType';

const fingerPrint = require('@/assets/img/fingerprint.png');

@Component
export default class PosterMask extends Vue {
    @Prop({ default: false, type: Boolean }) visible!: boolean;
    @Getter("instId") instId!: string;
    currentXcxCodeUrl: string = "";
    scene: string = "";
    posterCanvasUrl: string = "";
    @Watch("visible")
    getPosterData() {
        if (this.visible) {
        this.handleGenerateQrcode();
        }
    }
    handleGenerateQrcode(){
        let host: string = CONFIG.localServerB;
        if (process.env.NODE_ENV === "production") {
        host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
        }
        const query = {};
        const instId = this.instId;
        const ticket = {instId};
        console.log('instid:::',ticket)
        const params = {
          scene: JSON.stringify(ticket)
        };
        fetch.Sales('anon/commonMicroWebsite/generateSceneTicket', params).then((res: any) => {
            const currentXcxQrcode = `${host}sales/anon/commonMicroWebsite/getXcxCode?scene=${res.result}`;
            this.currentXcxCodeUrl = currentXcxQrcode;
            this.scene =  res.result;
          //   this.$nextTick(() => {
          //   const dom = document.querySelector('.share-poster-shadow');
          //   (html2canvas as any)(dom as HTMLElement, {
          //     useCORS: true,
          //     allowTaint: false,
          //   }).then((canvas: HTMLCanvasElement) => {
          //     this.posterCanvasUrl = canvas.toDataURL();
          //   });
          // });
        })
    }
    handleClose() {
        this.$emit('onClose');
    }
}
